import { Col, Row, OverlayTrigger, Tooltip, Alert } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { HiPhone } from "react-icons/hi2";
// import Search from "../component/Search";
import LinkDriverList from "../component/LinkDriverList";
import GoalAchievedCard from "../component/GoalAchievedCard";
import { FiLink } from "react-icons/fi";
// import { BiMessageSquareEdit } from "react-icons/bi";
import Func from "../function/Func";
import { useCallback, useEffect, useState } from "react";
import SessionUtil from "../util/SessionUtil";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import Pagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import ReactLoading from 'react-loading';

const Settings = () => {
    const { t } = useTranslation();
    const [data, setData] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [recordCount, setRecordCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const isLoggedIn = SessionUtil.isLoggedIn();
    const [alertMsg, setAlertMsg] = useState(null);

    const getApi = useCallback(async () => {
        let data = {
            "PageNumber": currentPage,
            "PageSize": "10",
            "OrderBy": "Id Desc",
        }
        const res = await ApiUtil.postApi(ApiPath.GET_ALL_CONNECT_DRIVER_WITH_OPERATIONS, data, 'POST');
        if (res.IsSuccessfull) {
            setData(res.Result.ConnectDriverWithOperationViewList)
            const totalPage = Math.ceil(res.Result.RecordCount / 10);
            setRecordCount(totalPage);
            setLoading(false);
        }
    }, [currentPage]);
    useEffect(() => {
        if (isLoggedIn) {
            getApi();
        }
    }, [getApi, isLoggedIn])

    const handlePageNumber = (pageNumber) => {
        setCurrentPage(pageNumber);
    }

    const handleUnlink = async (id) => {
        // handle unlink logic here
        let params = {
            "Id": id,
        };
        const res = await ApiUtil.postApi(ApiPath.UN_CONNECT_DRIVER_WITH_OPERATIONS, params, 'POST');
        if (res.IsSuccessfull) {
            getApi();
            setCurrentPage(1);
            setAlertMsg(true);
            setTimeout(() => {
                setAlertMsg(null);
            }, 5000)
        } else {
            setAlertMsg(false);
        }
    }

    // const handleEdit = (data) => {
    //     // handle edit logic here
    //     navigate(`/link-driver/${data.Id}`, {
    //         replace: true, state: {
    //             // pass data here
    //             username: data.DeliveryName,
    //         },
    //     });
    // }

    const nameWithPhone = (img, name, phone) => {
        const htmlCode = <div className="settings-style row-style font-13">
            <div className="flex-gap-2">
                {/* {img ? <Image alt="image" src={img} className="img-fluid" /> : <span className="img-empty"></span>} */}
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip id="button-tooltip-2">{name}</Tooltip>}>
                    <div className="flex-gap-2">
                        <span className="get-initials text-uppercase">{Func.getInitials(name)}</span>
                        <p className="mb-0">{name}</p>
                    </div>
                </OverlayTrigger>
            </div>
            <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip id="button-tooltip-2">{phone}</Tooltip>}>

                <div className="flex-gap-2">
                    <HiPhone size={16} color={"#3A974C"} /> +{phone}
                </div>
            </OverlayTrigger>
        </div>

        return htmlCode;
    }

    const getRowData = (rowData, index) => {
        const htmlCode = <div key={index} className="d-flex align-items-center mb-3 g-0 setting-container">
            <div className="d-flex align-items-center">
                {nameWithPhone(rowData.Img, rowData.DriverFirstName + ' ' + rowData.DriverLastName, rowData.DriverAreaCode + rowData.DriverPhoneNumber)}
                <FiLink size={20} className="rotate-45" />
                {nameWithPhone(rowData.Img, rowData.OperationFirstName + ' ' + rowData.OperationLastName, rowData.OperationAreaCode + rowData.OperationPhoneNumber)}
            </div>
            <div onClick={() => handleUnlink(rowData.Id)} className="unlink-style settings-style text-center justify-content-center">{t('Unlink')}</div>
            {/* <div onClick={() => handleEdit(rowData)} className="settings-style d-flex gap-2 edit-style"><BiMessageSquareEdit />{t('Edit')}</div> */}
        </div>

        return htmlCode;
    }
    return (
        <Row className="g-0">
            {!loading ? <>
                <Col lg={8} className="position-relative" >

                    <div className=" mt-4 d-flex justify-content-between gap-2">
                        <p className="title">{t('Driver with Operation')}</p>
                    </div>
                    {alertMsg !== null &&
                        (alertMsg ?
                            <Alert variant={'success'} className="mt-3">
                                {t('Unlink Driver with Operation Successfully')}
                            </Alert>
                            :
                            <Alert variant={'danger'} className="mt-3">
                                {t('Unlink Driver with Operation Failed')}
                            </Alert>)
                    }
                    <div className="w-100 overflow-auto">
                        {data.map((rowData, index) => {
                            return (
                                getRowData(rowData, index)
                            )
                        })}
                    </div>
                    <Pagination
                        current={currentPage}
                        total={recordCount}
                        onPageChange={(pageNumber) => handlePageNumber(pageNumber)}
                        extraClassName="justify-content-end"
                    />
                    {data.length === 0 && <div className='noData w-100'>{t('There is no information to display')}.</div>}

                </Col>

                <Col md={1}>
                    <div className="divider-vertical mx-auto"></div>
                </Col>
                <Col lg={3} className="mt-5">
                    {/* <Search /> */}
                    <LinkDriverList data={[]} dataDriverLink={data} type="linkDriver" />
                    <GoalAchievedCard />
                </Col>
            </> :
                <Col lg={12} className="loading-style">
                    <ReactLoading type={'bars'} color={'#c8c8c8'} height={'50px'} width={'50px'} />
                </Col>
            }
        </Row>
    );
}

export default Settings;